enum LocaleEnum {
	fr = 'fr-FR'
}

export default LocaleEnum